module.exports = __webpack_public_path__ + "img/coffee.12529abc.jpeg";